// Full-page curtain shown while the in-app PDF is built. captureCharts() has to
// work on the LIVE chart panels to shoot them — widen each to 900px, expand the
// legend, force the light theme — and those moves are ugly to watch. The public
// report link hides the same work behind a loader; this gives the drawer's
// Download the same cover: the user sees a blank page with the loader, then
// the file arrives and the report is back exactly as it was.
//
// Colours are frozen from the theme at mount as inline styles, NOT tokens: the
// capture flips <html data-theme> to light halfway through, and a token-driven
// curtain would flash with it.
import { useState } from 'react'
import { createPortal } from 'react-dom'
import { DotMatrix } from '@clickguard/design-system'

const isDarkTheme = () => document.documentElement.dataset.theme === 'dark'

export const DownloadOverlay = ({
	label = 'Preparing your report…'
}: {
	label?: string
}) => {
	const [dark] = useState(isDarkTheme)
	return createPortal(
		<div
			role="status"
			aria-live="polite"
			style={{
				position: 'fixed',
				inset: 0,
				// Above the Share drawer (z-[9999]) and its portaled dialogs (z-[10000]).
				zIndex: 10001,
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				justifyContent: 'center',
				gap: 16,
				background: dark ? '#151326' : '#fafafa',
				color: dark ? '#e5e7eb' : '#4b5563'
			}}
		>
			<DotMatrix size="lg" label={label} />
			<p style={{ margin: 0, fontSize: 15 }}>{label}</p>
		</div>,
		document.body
	)
}
